<template>
  <div
    data-qa="screen_confirm_email"
    class="d-flex flex-column align-center pa-6 rounded"
    rounded
  >
    <v-img
      src="/static/_v1/pd/pictures/ui-kit/mail.svg"
      class="mb-4"
      width="212"
      height="212"
      :alt="t('Почта', options)"
    />
    <div
      class="text-center text--text"
      :class="isMobile ? 'text-h6 mb-4' : 'text-h5 mb-2'"
    >
      {{ t('Подтвердите ваш email', options) }}
    </div>
    <div class="text-center text-body-1 text-secondary--text">
      {{ t('Отправили письмо для подтверждения на', options) }}
      <span
        v-if="userEmail"
        data-qa="screen_confirm_email_user_email"
      >
        {{ userEmail }}
      </span>
      <span
        v-if="dateOfSendingEmailText"
        data-qa="screen_confirm_email_date_of_sending_email"
        class="text-no-wrap"
      >
        {{ dateOfSendingEmailText }}
      </span>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { format, parse } from 'date-fns'
import { ru } from 'date-fns/locale'
import I18NextVue from 'i18next'
import type { ContextStore } from 'src/components/pages/profile/lpus/register/index/types'
import useContextStore from 'src/store/useContextStore'

const { t, language } = I18NextVue
const options = { ns: language }

const props = defineProps<{
  userEmail?: string
  dateOfSendingEmail?: string | false
}>()

const { context }: ContextStore = useContextStore()
const isMobile = computed(() => context.flavour === 'mobile')

const dateOfSendingEmailText = computed(() => {
  if (!props.dateOfSendingEmail) {
    return ''
  }

  try {
    const date = parse(props.dateOfSendingEmail, 'yyyy-MM-dd HH:mm:ss.SSSSSS', new Date())

    return format(date, 'dd MMMM yyyy', { locale: ru })
  } catch {
    return ''
  }
})
</script>
